import { axios } from "utils";

import { ADMIN_FIELDS_URL as endpoint } from "consts";

import {
  BasicFieldDetails,
  CropPracticesRequestBody,
  CropPracticesResponse,
  FieldListField,
  FieldPracticeResponse,
  FieldShape,
  FieldSizeUpdate,
  SocSample,
} from "models";

// TODO: Add types to the data parameters here
/* eslint-disable @typescript-eslint/no-explicit-any */

export const getAllFields = async (data: any): Promise<{ fields: any[]; count: number }> => axios.get(`${endpoint}`, { data });

export const getAdminFieldListByFarmId = async ({ farmId }: { farmId: string }): Promise<FieldListField[]> => axios.get(`${endpoint}/list?farmId=${farmId}`);

export const getFieldSizeUpdates = async (data: any): Promise<FieldSizeUpdate[]> => axios.get(`${endpoint}/${data.fieldId}/size-updates`, { data });

export const getFieldShapeAdmin = async (data: { fieldId: string; type?: string }): Promise<{ fieldShape: FieldShape }> =>
  axios.get(`${endpoint}/${data.fieldId}/shape`, { data });

export const getFieldAdmin = async (data: { id: string; includeDisabledFields?: boolean; signal: AbortSignal }): Promise<any> =>
  axios.get(`${endpoint}/${data.id}${data.includeDisabledFields ? "?includeDisabledFields=true" : ""}`, { signal: data.signal });

export const updateFieldShapeAdmin = async (data: any) => axios.put(`${endpoint}/${data.fieldId}/shape`, { data });

export const uploadFieldsAdmin = async (data: any) => axios.post(`${endpoint}/upload`, { data });

export const getDigifarmMapsGeo = async (data: any) => axios.get(`${endpoint}/shapes/digifarm`, { data });

export const addGoogleMapsPolygon = async (data: any) => axios.post(`${endpoint}/${data.fieldId}/shapes/google-polygons`, { data });

export const deleteGooglePolygon = async (data: any) => axios.delete(`${endpoint}/${data.fieldId}/shapes/google-polygons`, { data });

export const getCropsDataByYear = async (data: any) => axios.get(`${endpoint}/${data.fieldId}/field-modules/crops/${data.year}`, { data });

export const getFieldModulesByFieldId = async (data: any) => axios.get(`${endpoint}/${data.fieldId}/field-modules`, { data });

export const getHaInConversionPrediction = async (data: any) => axios.get(`${endpoint}/ha-in-conversion-predictions`, { data });

export const processFieldRegionsAdmin = async (data: any) => axios.post(`${endpoint}/regions`, { data });

export const disableFieldModulesByFieldId = async (data: { fieldId: string; signal: AbortSignal }): Promise<void> =>
  axios.delete(`${endpoint}/${data.fieldId}/field-modules`, { signal: data.signal });

export const addSocSample = async (data: { fieldId: string; soc: number }): Promise<SocSample> =>
  axios.post(`${endpoint}/${data.fieldId}/soc-samples`, { data });

export const getSocSamples = async (data: { fieldId: string }): Promise<SocSample[]> => axios.get(`${endpoint}/${data.fieldId}/soc-samples`);

export const getFieldPracticesAdmin = async (data: { fieldId: string }): Promise<FieldPracticeResponse> => axios.get(`${endpoint}/${data.fieldId}/practices`);

export const addFieldCropPracticeAdmin = async ({
  fieldId,
  requestBody,
}: {
  fieldId: string;
  requestBody: CropPracticesRequestBody;
}): Promise<CropPracticesResponse> => axios.post(`${endpoint}/${fieldId}/crops`, { data: requestBody });

export const updateFieldCropPracticeAdmin = async ({
  fieldId,
  cropId,
  requestBody,
}: {
  fieldId: string;
  cropId: string;
  requestBody: CropPracticesRequestBody;
}): Promise<CropPracticesResponse> => axios.put(`${endpoint}/${fieldId}/crops/${cropId}`, { data: requestBody });

export const deleteFieldCropPracticeAdmin = async ({ fieldId, cropId }: { fieldId: string; cropId: string }): Promise<CropPracticesResponse> =>
  axios.delete(`${endpoint}/${fieldId}/crops/${cropId}`);

export const getFarmFieldListAtPointInTimeAdmin = async ({ farmId, date }: { farmId: string; date: string }): Promise<FieldListField[]> =>
  axios.get(`${endpoint}/list?farmId=${farmId}&date=${date}`);

export const getFieldBasicDetailsAdmin = async (fieldId: string, includeDisabledFields?: boolean): Promise<BasicFieldDetails> =>
  axios.get(`${endpoint}/${fieldId}/basic-details${includeDisabledFields ? "?includeDisabledFields=true" : ""}`);
